import React from 'react';
import RouteWrapperEffectsHandler from './RouteWrapperEffectsHandler.jsx';
import GtmTag from '../GtmTag.jsx';

const RouteWrapper = (props) => {
  const isSignupPage = props.routeSlug === 'signup' || props.routeSlug === 'signupAlt';

  return (
    <>
      <RouteWrapperEffectsHandler {...props} />
      {isSignupPage && <GtmTag id={'AW-10897846390'} />}
      <props.element {...props} />
    </>
  );
};

export default RouteWrapper;
